import React from "react";
import Box from "@mui/material/Box";
import Header from "./Header";
import { MobileChromeProvider } from "./MobileChromeContext";
import { MOBILE_MAIN_BOTTOM_PAD } from "./headerLayout";

/**
 * Authenticated app shell. Mobile navigation lives in the header menu —
 * no bottom tab bar (avoids duplicating destinations and frees viewport).
 */
const MainLayout = ({
  children,
  chatNavigationDisabled = false,
  disableMobileBottomPadding = false,
}) => {
  return (
    <MobileChromeProvider>
      <Header chatNavigationDisabled={chatNavigationDisabled} />
      <Box
        component="div"
        sx={{
          pb: disableMobileBottomPadding ? 0 : { xs: MOBILE_MAIN_BOTTOM_PAD, md: 0 },
        }}
      >
        {children}
      </Box>
    </MobileChromeProvider>
  );
};

export default MainLayout;
